<template>
  <doughnut :chartdata="chartdata" :options="options"/>
</template>

<script>
import Doughnut from '@/components/charts/doughnut'

export default {
  name: 'BackupServiceByType',
  components: {
    Doughnut
  },
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      chartdata: null,
      options: {
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },
  methods: {
    fillchartdata: function () {
      this.chartdata = {
        labels: [
          'shelvery',
          'automated',
          'manual',
          'awsbackup'
        ],
        datasets: [
          {
            label: 'total',
            backgroundColor: ['#06d6a0', '#ffd166', '#ef476f', '#118ab2'],
            data: this.data
          }
        ]
      }
    }
  },
  watch: {
    data: function () {
      this.fillchartdata()
    }
  },
  created: function () {
    this.fillchartdata()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/BackupServiceByType.vue